import { Popover } from '@headlessui/react'
import clsx from 'clsx'
import { TailwindPopOver } from 'components/modal'
import { Typography } from 'components/typography'
import { TypographyTypes } from 'interfaces'
import React, { useEffect, useState } from 'react'
import { usePopper } from 'react-popper'
import { TagTableProps } from './TagTable.type'

export const TagTable: React.FC<TagTableProps> = ({
	list,
	className,
	titlePopover
}) => {
	const [quantityElement, setQuantityElement] = useState<number>(0)
	const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
		null
	)
	const [referenceElement, setReferenceElement] =
		useState<HTMLButtonElement | null>(null)
	const { styles, attributes } = usePopper(referenceElement, popperElement)

	useEffect(() => {
		if (list) {
			setQuantityElement(list.length - 1)
		}
	}, [list])

	return (
		<div className="flex gap-2 items-center">
			<Popover className={className}>
				<div className="flex gap-1">
					{list && (
						<Popover.Button
							className={clsx(
								'flex items-center justify-center p-1 border border-blue-primary rounded-[8px] max-h-[25px] gap-1'
							)}
							ref={setReferenceElement}
						>
							<Typography
								key="0"
								title={list[0]?.name}
								fontLeading="12/15"
								type={TypographyTypes.span}
								className={clsx('!font-normal text-blue-primary truncate')}
							/>
						</Popover.Button>
					)}
					{!!quantityElement && (
						<Popover.Button
							className="flex items-center justify-center p-1 border border-blue-primary rounded-3xl w-[35px] h-[25px]"
							ref={setReferenceElement}
						>
							<Typography
								key="0"
								title={`+${quantityElement}`}
								fontLeading="12/15"
								type={TypographyTypes.span}
								className="!font-normal text-blue-primary "
							/>
						</Popover.Button>
					)}
				</div>
				<Popover.Panel
					className="absolute z-10 !-left-[35px]"
					ref={setPopperElement}
					style={styles.popper}
					{...attributes.popper}
				>
					{({ close }) => (
						<TailwindPopOver
							handleClose={close}
							title={titlePopover}
							className={clsx(
								'w-[185px] h-max rounded-[16px] border-2 border-gray-3 gap-1 '
							)}
						>
							<div>
								{list?.map(elements => {
									return (
										<div className="border-black-1 pt-2">
											<div
												className="flex items-center justify-center gap-1 p-1 border border-blue-primary rounded-[8px] w-max"
												key={`${elements.name}_${elements.id}`}
											>
												<div className="flex gap-1">
													<Typography
														title={elements.name}
														fontLeading="12/15"
														type={TypographyTypes.p}
														className={clsx(
															'!font-normal  text-blue-primary truncate max-w-[115px]'
														)}
													/>
												</div>
											</div>
										</div>
									)
								})}
							</div>
						</TailwindPopOver>
					)}
				</Popover.Panel>
			</Popover>
		</div>
	)
}
